module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-fr@3x.aa0dc34c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-fr@3x.png
// module id = 309
// module chunks = 0